import { FormattedMessage } from 'react-intl'
import { Button } from '@mui/material'
import LoadingSpinner from 'components/ui/LoadingSpinner'

interface Props {
  status: RequestStatus
  onClick: () => void
}

export default function LoadMoreButton({ status, onClick }: Props): JSX.Element {
  return (
    <Button onClick={onClick} color="primary" variant="contained" disabled={status === 'loading'}>
      {status === 'loading' ? <LoadingSpinner size={24} /> : <FormattedMessage id="strings.loadMore" />}
    </Button>
  )
}
